  <ul class="timeline timeline--sm-bullet pl-1 pt-4">
  <li class="timeline__item" *ngFor="let item of history; let i = index; last as isLast">
    <div class="timeline__bullet">
      <span class="timeline__bullet-shape"></span>
    </div>
    <app-row *ngIf="item?.avlDistance &&
          item.action == ShipmentAction.ArrivePickupLocation ||
          item.action == ShipmentAction.GoodsDelivered">
      <app-col cols="5">
        <div class="timeline__item-title">
          <p class="small">
            {{ "Enum.ShipmentStatus." + item.action | translate}} {{item.createdBy?.userType === UserType.DRIVER &&
            (item.createdBy?.firstName &&
            item.createdBy?.lastName) ? "(" + ("Shipments.DriverAccepted" | translate) + ")" : "(" +
            item.createdBy?.firstName + " " +
            item.createdBy?.lastName + ")"}}
          </p>
        </div>
        <div class="timeline__item-separator" *ngIf="!isLast"></div>
      </app-col>

      <app-col sm="3">
        <p class="small" *ngIf="item?.avlDistance &&
          item.action == ShipmentAction.ArrivePickupLocation ||
          item.action == ShipmentAction.GoodsDelivered">
          <span class="timeline__item-content pl-8">{{(+item?.avlDistance)?.toFixed(2)}} {{"Shipments.km" | translate}}</span>
        </p>
      </app-col>

      <app-col sm="auto" class="ml-auto">
        <span
          class="timeline__item__content small weight-normal text-500">{{item?.createdAt | date : 'dd-MM-yyyy hh:mm aa'}}</span>
      </app-col>
    </app-row>
  </li>
</ul>
